import { cn } from "@/lib/utils";
import { Car } from "lucide-react";

type Props = {
  src: string | null | undefined;
  alt?: string;
  className?: string;
  iconClassName?: string;
};

export function ProductImageThumb({ src, alt = "", className, iconClassName }: Props) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={cn("h-full w-full object-cover", className)}
        loading="lazy"
      />
    );
  }

  return (
    <div className={cn("flex h-full w-full items-center justify-center bg-muted", className)}>
      <Car className={cn("h-6 w-6 text-muted-foreground/40", iconClassName)} aria-hidden />
    </div>
  );
}
